import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { makeCustomInputProviders } from '../custom-input-component.abstract';
import { InputFieldComponent } from '../input-field.component';

import { InputExpandOnFocusDirective } from './input-expand-on-focus.directive';

@Component({
  standalone: true,
  selector: 'shrd-uic-input-expandable-field',
  templateUrl: './input-expandable-field.component.html',
  styleUrls: ['../input-field.component.scss'],
  imports: [ReactiveFormsModule, InputExpandOnFocusDirective, NgIf],
  providers: makeCustomInputProviders(InputExpandableFieldComponent),
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputExpandableFieldComponent extends InputFieldComponent {
  @Input() expandOnFocusSize: string;
  @Input() expandOnFocusChildClass: string;

  @ViewChild(InputExpandOnFocusDirective) inputExpandOnFocusDirective: InputExpandOnFocusDirective;

  @HostListener('keydown.escape', ['$event'])
  protected onKeyEscape(event: KeyboardEvent): void {
    event.preventDefault();
    this.blur();
  }

  restoreInputInitialState(): void {
    this.inputExpandOnFocusDirective?.restoreInputInitialState();
  }
}
